import { render, staticRenderFns } from "./ISFDetailReference.vue?vue&type=template&id=1f7a79a9&"
import script from "./ISFDetailReference.vue?vue&type=script&lang=js&"
export * from "./ISFDetailReference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports